import React, { useState, useEffect, useRef } from "react"
import "./style.scss";
import { Question, QuestionData } from "../../global-interfaces";
import { makeScaleLinear } from "../../utils"
import { format, max, ScaleLinear } from "d3";
import Classnames from "classnames";

const pct_format: any = format(".0%");

interface Props {
  chart: Question;
  color: string | null;
}

export default function VerticalMany( {chart, color } : Props) {
  
  /* APP STATE */
  const data = chart.data;
  const chartRef = useRef(null)

  /* TRANSFORMATIONS */
  /** custom scale so that if the values are all less than 25%, the domain is 0-50% instead of 0-100% */
  const domainMax = (chart.scale === 1 ? max(data, d => d.value) : chart.scale) || 1
  const scale = makeScaleLinear([0, domainMax])
  const opacityScale = makeScaleLinear([0, domainMax], [0.2,1])

  return (
    <div className={Classnames("VerticalMany", color)} ref={chartRef}>
      <div className="bars-container">
        {data.map((d: QuestionData) => <div className={Classnames("bar-group")}> 
          <div className={Classnames("bar-label")} style={{ 
            top: pct_format(1 - (scale(d.value) || 0))
          }}>{d.label}</div>
          <Bar value={d.value} sizeScale={scale} opacityScale={opacityScale} />
        </div>)}
      </div>
      {chart.category && <div className="category-label selected">{chart.category}</div>}
    </div>
  )

}

interface BarProps {
  opacityScale: ScaleLinear<number, number>, 
  sizeScale: ScaleLinear<number, number>, 
  value: number
}

function Bar({ opacityScale, sizeScale, value } : BarProps ) {
  /** The opacity of the bar would pass along to the span below, so this solution
   * with a `bar-measure-parent` allows the span to not inherit the opacity of the larger div*/
  return <div className="bar-measure-parent" style={{ height: pct_format(sizeScale(value)) }}>
    <div className="bar-measure" style={{ opacity: opacityScale(value) }} />
    <span>{pct_format(value)}</span>
  </div>
}
